<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Anggota</h5>
            </template>
            <div>
                <b-row>
                    <b-col cols="12" md="6" lg="4" class="mb-3">
                        <b-form-input @keyup.enter="onFilter" v-model="input.filterName" name="filterNamaAnggota" id="filterInput"
                            type="search" placeholder="Nama Anggota"></b-form-input>
                    </b-col>
                    <b-col cols="12" md="6" lg="4" class="mb-3">
                        <b-form-input @keyup.enter="onFilter" v-model="input.filterNoAnggota" name="filterNoAnggota" type="search"
                            placeholder="No. Anggota"></b-form-input>
                    </b-col>
                    <b-col cols="12" md="6" lg="4" class="mb-3">
                        <b-form-input @keyup.enter="onFilter" v-model="input.filterNoIdentitas" name="filterNoIdentitas" type="search"
                            placeholder="No. Identitas"></b-form-input>
                    </b-col>
                    <b-col cols="12" md="6" lg="4" class="mb-3">
                        <b-form-input @keyup.enter="onFilter" v-model="input.filterNoHandphone" name="filterNoHandphone" type="search"
                            placeholder="No. Handphone"></b-form-input>
                    </b-col>
                    <b-col cols="12" md="6" lg="4" class="mb-3">
                        <b-form-select v-model="input.filterIsActive" id="filterSpek" name="filterSpek"
                            value-field="value" text-field="text">
                            <b-select-option :value="null" selected disabled>-- Status --</b-select-option>
                            <b-select-option :value="true">Aktif</b-select-option>
                            <b-select-option :value="false">Blacklist</b-select-option>
                        </b-form-select>
                    </b-col>
                    <b-col cols="12" md="6" lg="4" class="mb-3">
                        <div class="d-flex" style="gap: 8px;">
                            <b-button variant="pgiBtn" name="searchTableBtn" :disabled="isBusy" @click="onFilter">
                                <i class="fa fa-search"></i>
                            </b-button>
                            <b-button variant="pgiBtn" name="reseFilterBtn" :disabled="isBusy" @click="onReset">Reset</b-button>
                            <b-button variant="pgiBtn" name="searchTableBtn" :disabled="isBusy" @click="onFilter">
                                Refresh
                            </b-button>
                        </div>
                    </b-col>
                    <b-col cols="12" class="mb-3">
                        <div class="d-flex" style="gap: 8px;">
                            <b-button variant="pgiBtn" name="anggotaAddBtn" @click="inputSE">Surat Edaran</b-button>
                            <b-button variant="pgiBtn" name="anggotaAddBtn" @click="inputAnggota">Input Anggota</b-button>
                        </div>
                    </b-col>
                </b-row>
            </div>
            <b-table bordered hover show-empty :busy="isBusy" :items="anggota" :fields="fields" :no-local-sorting="false"
                @sort-changed="sortingChanged" responsive class="mb-3">
                <template v-slot:table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong> Loading data...</strong>
                    </div>
                </template>
                <template v-slot:empty>
                    Tidak ada data anggota.
                </template>
                <template v-slot:cell(nama)="row">
                    <span>{{ row.item.nama }}</span>
                    <FieldApproval
                        label="Nama Anggota"
                        :field-key="`name-${row.item.id}`"
                        :current-value="row.item.nama"
                        :selected-row="row.item"
                        :loading="false"
                        @submit="showModalConfirmEditAnggota"
                    />
                </template>
                <template v-slot:cell(noHp)="row">
                    <span>{{ row.item.noHp }}</span>
                    <FieldApproval
                        label="No Handphone"
                        :field-key="`no-handphone-${row.item.id}`"
                        :current-value="row.item.noHp"
                        :selected-row="row.item"
                        :loading="false"
                        :showUpload="true"
                        @submit="showModalConfirmEditAnggota"
                    />
                </template>
                <template v-slot:cell(noIdentitas)="row">
                <div v-if="row.item.identitas && row.item.identitas.length > 0">
                    <div v-for="(item, idx) in row.item.identitas" :key="idx">
                    <a style="font-weight:bold" v-if="idx===0">{{item.jenisIdentitas + " " + item.noIdentitas}}</a>
                    <a style="color:gray" v-else>{{item.jenisIdentitas + " " + item.noIdentitas}}</a>
                    
                    <!-- <p class="mb-0">{{ item.noIdentitas }}</p>
                    <p class="mb-0 text-muted">{{ item.jenisIdentitas }}</p> -->
                    </div>
                    <!-- {{row.item}} -->
                </div>
                <b-button
                    size="sm"
                    variant="pgiBtn"
                    @click="showIdentitas(row.item)"
                >
                    <i class="fa fa-edit"></i>
                </b-button>
                    <!-- <p class="mb-0">{{ row.item.identitas.length>0 ? row.item.identitas[0].noIdentitas : "-" }}</p>
                    <p class="mb-0 text-muted">{{ row.item.identitas.length>0 ? row.item.identitas[0].jenisIdentitas :  "-" }}</p> -->
                </template>
                <template v-slot:cell(isActive)="row">
                    <b-badge v-if="row.item.isActive" variant="success">Aktif</b-badge>
                    <b-badge v-else variant="danger">Blacklist</b-badge>
                </template>
                <template v-slot:cell(action)="row">
                    <div class="no-wrap">
                        <b-link :to="`${$route.path}/${row.item.id}`">
                            <b-button size="sm" class="mr-2 table-button view" v-b-tooltip.hover title="Detail"
                                name="anggotaViewBtn">
                                <i class="fa fa-info"></i>
                            </b-button>
                        </b-link>
                        <b-link :to="`${$route.path}/${row.item.id}/edit`">
                            <b-button size="sm" class="table-button edit mr-2" v-b-tooltip.hover title="Edit"
                                name="anggotaEditBtn">
                                <i class="fa fa-pencil-square-o"></i>
                            </b-button>
                        </b-link>
                        <b-button v-if="row.item.isActive && hasAccess" class="btn btn-sm mr-2" v-b-tooltip.hover title="Blacklist"
                            variant="danger" @click="blackList(row.item.id)">
                            <i class="fa fa-ban"></i>
                        </b-button>
                        <b-button v-if="!row.item.isActive && hasAccess"  class="btn btn-sm mr-2" v-b-tooltip.hover title="Lepas Blacklist" variant="primary"
                            @click="unBlacklist(row.item.id)">
                            <i class="fa fa-ban"></i>
                        </b-button>
                        <b-button
                            @click="onShowModalListRekening(row.item)"
                            size="sm"
                            variant="pgiBtn"
                        >
                            <i class="fa fa-credit-card"></i>
                        </b-button>
                    </div>
                </template>
            </b-table>
            <div class="pagination-wrapper d-flex align-items-center justify-content-between">
                <b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
                    <b-form-select v-model="input.show" id="showItems" @change="onLimitChange" :options="options">
                        <template v-slot:first>
                            <b-form-select-option :value="null" disabled />
                        </template>
                    </b-form-select>
                    <span class="ml-2">{{ totalViewText }}</span>
                </b-input-group>
                <b-pagination class="mb-0" v-model="currentPage" :total-rows="rows" :per-page="perPage"
                    aria-controls="my-table" @input="onPageChange"></b-pagination>
            </div>

        </b-card>

        <!-- MODAL SHOW SE -->
        <b-modal id="modal-SE" size="sm" title="Surat Edaran Anggota" no-close-on-backdrop no-close-on-esc>
            <FormulateInput v-if="url.length != 0" name="urlPDF" ref="urlPDF" type="file" :value="url"
                help="Format Harus PDF" accept=".pdf" validation="mime:application/pdf" multiple />
            <FormulateInput type="file" name="file" help="Format Harus PDF" validation="mime:application/pdf" accept=".pdf"
                fileRemove multiple />

            <template v-slot:modal-footer="{ ok }">

                <b-button variant="primary" name="closePreviewBtn" @click="confirmSubmitSE">
                    Submit
                </b-button>
                <b-button variant="secondary" name="closePreviewBtn" @click="cancel()">
                    Close
                </b-button>
            </template>
        </b-modal>

        <b-modal id="modal-blacklist" title="Blacklist Anggota" no-close-on-backdrop>
            <div class="my-2">
                <label>Perihal</label>
                <multiselect v-model="form.regarding" :options="perihalOpt" :internal-search="true"
                        :allow-empty="false" deselect-label="" select-label="" label="name" track-by="id"
                        placeholder="-- Please select an option --" />
            </div>
            <div class="my-2">
                <label>Alasan Blacklist</label>
                <b-form-textarea class="mr-2" v-model="form.reason" name="alasan" id="alasan" placeholder="Alasan..."
                    maxlength="255"></b-form-textarea>
            </div>
            <template v-slot:modal-footer="{ cancel }">
                <b-button variant="secondary" name="closeDetailBtn" @click="cancel()">
                    Tutup
                </b-button>
                <b-button variant="pgiBtn" :disabled="loading" name="closeDetailBtn" @click="confirmBlacklist()">
                    {{ loading ? 'Loading...' : 'Submit' }}
                </b-button>
            </template>
        </b-modal>

        <b-modal id="modal-unBlacklist" title="Lepas Blacklist" no-close-on-backdrop>
            <p>Alasan Blacklist : {{ activeItem && activeItem.reason }}</p>
            <p>Oleh : {{ activeItem && activeItem.createdBy }} , {{ $helper.changeDateFormat(activeItem &&
                activeItem.createdAt) }} {{ $helper.changeDateFormatGetHour(activeItem && activeItem.createdAt) }}
            </p>
            <div class="my-2">
                <label>Alasan Lepas Blacklist</label>
                <b-form-textarea class="mr-2" v-model="form.reason" name="alasan" id="alasan" placeholder="Alasan..."
                    maxlength="255"></b-form-textarea>
            </div>
            <template v-slot:modal-footer="{ cancel }">
                <b-button variant="secondary" name="closeDetailBtn" @click="cancel()">
                    Tutup
                </b-button>
                <b-button variant="pgiBtn" :disabled="loading" name="closeDetailBtn" @click="confirmUnBlacklist()">
                    {{ loading ? 'Loading...' : 'Submit' }}
                </b-button>
            </template>
        </b-modal>

        <ModalConfirm id="modal-confirm-submit-se" title="Confirm Submit surat edaran anggota" :isSubmitting="isSubmitting"
            desc="Apakah anda yakin untuk input surat edaran ini?" @submit="onSubmitSE" />
        <ModalConfirm id="modal-hapus-se" title="Confirm Hapus SE" desc="SE Akan Terhapus Permanen" @submit=removeSE />
        <ModalConfirm id="conf-blacklist" title="Konfirmasi Blacklist" :isSubmitting="loading"
            desc="Apakah anda yakin untuk Blacklist Anggota ini ?" @submit="onSubmitBlacklist" />
        <ModalConfirm id="conf-unBlacklist" title="Konfirmasi Lepas Blacklist" :isSubmitting="loading"
            desc="Apakah anda yakin untuk Lepas Blacklist Anggota ini ?" @submit="onSubmitUnBlacklist" />

    <ModalIdentitas
      :isModal="true"
      :idAnggota="anggotaDetail.id"
      :dataAnggota="anggotaDetail"
      :getListAnggota="getAnggota"
    />
    <ModalListRekeningBank 
        :stateListRekening="stateListRekening"
        :dataListRekening="stateListRekening.data"
        :userData="selectedRow ? selectedRow : {}"
        :showAktif="true"
        :showNonAktif="true"
        @onSubmitInactiveRekening="getListRekening()"
        @onSubmitActiveRekening="getListRekening()"
    />

    <ModalConfirm id="modal-request-edit-no-handphone" title="Konfirmasi Perubahan No Handphone Anggota"
        :isSubmitting="isLoadingReqApproval" desc="Apakah Anda yakin ingin ubah no handphone anggota ini?"
        @submit="handleApproval('no-handphone')" />

    <ModalConfirm id="modal-request-edit-name" title="Konfirmasi Perubahan Nama Anggota" :isSubmitting="isLoadingReqApproval"
        desc="Apakah Anda yakin ingin ubah nama anggota ini?" @submit="handleApproval('name')" />
    </div>
</template>

<script>
import Vue from 'vue'
import VueFormulate from '@braid/vue-formulate'
import ModalIdentitas from "../../gadai/ModalIdentitas.vue";
import ModalListRekeningBank from '@/components/modals/ModalListRekeningBank'
import FieldApproval from '@/components/common/FieldApproval'

Vue.use(VueFormulate)
export default {
    name: 'master-anggota',
    components : {
        ModalIdentitas,
        ModalListRekeningBank,
        FieldApproval,
    },
    data() {
        return {
            hasAccess: (localStorage.getItem('menuChildren').includes("BUN")) ? true : false,
            initStatus: 0,
            isBusy: true,
            input: {
                show: 10,
                filterName: null,
                filterNoAnggota: null,
                filterNoIdentitas: null,
                filterNoHandphone: null,
                filterIsActive: null,
                sortBy: null,
                sortDesc: null,
                filePDF: null
            },
            form: {
                reason: '',
                regarding: null
            },

            options: [
                { value: 10, text: '10' },
                { value: 20, text: '20' },
                { value: 30, text: '30' },
                { value: 40, text: '40' },
                { value: 50, text: '50' },
            ],
            fields: [
                { key: "nama", label: "Nama Anggota", sortable: true },
                { key: "noIdentitas", label: "No. Identitas", sortable: true },
                { key: "no", label: "No. Anggota", sortable: true },
                { key: "noHp", label: "No. Handphone", sortable: true },
                { key: "isActive", label: "Status" },
                { key: "action", label: "Aksi" },
            ],
            anggota: [],
            currentPage: 1,
            perPage: 10,
            rows: null,
            totalViewText: "",
            page: '',
            size: '',
            loading: false,
            query: "",

            pdf: {
                urlPDF: {
                    fileList: []
                }
            },
            url: [],

            activePdfPreview: "",
            activeItem: null,

            pdfRecords: [],
            pdfNewVal: [],
            hapusSE: [],
            idModal: 0,

            isSubmitting: false,

            perihalOpt: [],
            anggotaDetail:{},
            selectedRow: {},
            stateListRekening: {
                isLoading: false,
                data: [],
                error: null,
            },
            isLoadingReqApproval: false,
        }
    },

    methods: {

        //----------------- Fungsi Inisialisasi -----------------

        init() {
            this.initStatus = 0
            this.page = 0
            this.size = this.input.show
            this.query = this.$helper.makeQuery(this.page, this.size)

            // let getAnggota = this.$axios.get("nasabah/" + this.query).then(response => {
            //     this.anggota = response.data.data
            //     this.updateTotalItem(response.data.total)

            // })

            let getSe = this.$axios.get("surat-edaran/list/?menu=anggota&jenis=anggota").then(response => {

                for (var file of response.data) {
                    this.url.push({
                        id: file.id,
                        url: file.filepath,
                    })
                }

                this.urlRecord = this.url
            })

            let getOptionPerihal = this.$axios.get(`/perihal/?type=2&isActive=true`).then(response => {
                this.perihalOpt = response.data
            })

            Promise.all([getSe, getOptionPerihal]).then(() => {
                this.initStatus = 1
                this.toggleBusy()
            })
                .catch(error => {
                    console.log(error)
                    this.initStatus = -1
                })
        },


        //----------------- Fungsi Ambil Data Anggota -----------------
        getAnggota() {
            this.toggleBusy()
            this.anggota = []

            const params = {
                page: this.currentPage - 1,
                size: this.perPage,
            }

            if (!this.$helper.isNullOrEmpty(this.input.filterNoAnggota)) {
                params.filterNoAnggota = this.input.filterNoAnggota
            }

            if (!this.$helper.isNullOrEmpty(this.input.filterNoIdentitas)) {
                params.filterNoIdentitas = this.input.filterNoIdentitas
            }

            if (!this.$helper.isNullOrEmpty(this.input.filterNoHandphone)) {
                params.filterNoHandphone = this.input.filterNoHandphone
            }

            if (!this.$helper.isNullOrEmpty(this.input.filterName)) {
                params.filterName = this.input.filterName
            }

            if (!this.$helper.isNullOrEmpty(this.input.filterIsActive) || this.input.filterIsActive == false) {
                params.filterIsActive = this.input.filterIsActive
            }

            if (!this.$helper.isNullOrEmpty(this.input.sortBy)) {
                params.sortBy = this.input.sortBy
            }

            if (!this.$helper.isNullOrEmpty(this.input.sortDesc)) {
                params.sortDesc = this.input.sortDesc
            }

            if (Object.keys(params).length === 0) {
                this.toggleBusy()
                return
            }

            this.$axios.get("nasabah/", { params }).then(response => {
                this.anggota = response.data.data
                this.toggleBusy()
                this.updateTotalItem(response.data.total)
                this.loading = false
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
                this.toggleBusy()
                this.loading = false
            })
        },


        //----------------- Fungsi Pagination, Sorting, dan loading -----------------

        onLimitChange() {
            this.size = this.input.show
            this.perPage = this.input.show
            this.currentPage = 1
            this.page = 0
            this.query = this.$helper.makeQuery(0, this.size)
            this.getAnggota()
        },

        onPageChange() {
            if (this.loading == false) {
                this.page = this.currentPage - 1
                this.query = this.$helper.makeQuery(this.page, this.size)
                this.getAnggota()
            }
        },

        sortingChanged(ctx) {
            if (ctx.sortBy != "") {
                this.input.sortBy = ctx.sortBy
                this.input.sortDesc = ctx.sortDesc
                this.onFilter()
            }
        },

        onReset() {
            this.input.filterNoAnggota = null
            this.input.filterNoIdentitas = null
            this.input.filterNoHandphone = null
            this.input.filterName = null
            this.input.filterIsActive = null
            this.currentPage = 1
            this.page = 0
            this.query = this.$helper.makeQuery(0, this.size)
            this.loading = true
            this.getAnggota()
        },

        onFilter() {
            this.page = 0
            this.currentPage = 1
            this.query = this.$helper.makeQuery(0, this.size)
            this.loading = true
            this.getAnggota()
        },


        //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------

        toggleBusy() {
            if (this.isBusy == true) this.isBusy = false
            else this.isBusy = true
        },

        updateTotalItem(total) {
            let limit = null
            let prevLimit = null
            this.perPage = this.size
            this.rows = total
            prevLimit = this.page * this.size + 1
            limit = this.page * this.size + this.size
            if (limit > this.rows) limit = this.rows
            this.totalViewText = "Menampilkan " + prevLimit + " - " + limit + " dari " + this.rows + " entri"
        },

        inputAnggota() {
            this.$router.push({ path: `${this.$route.path}/input` });
        },

        inputSE() {
            this.$router.push({ path: `${this.$route.path}/inputSE` });
        },

        showModalSE() {
            this.idModal++

            this.$bvModal.show('modal-SE')
        },

        confirmSubmitSE() {

            if (this.input.filePDF == null) {
                this.$helper.toastErr(this, 'Surat edaran perlu di upload')
                return
            }
            else {
                if (this.input.filePDF.length == 0) {
                    this.$helper.toastErr(this, 'Surat edaran perlu di upload')
                    return
                }
                else {
                    for (var file of this.input.filePDF) {

                        if (file.type != null) {
                            if (file.type != "application/pdf") {
                                this.$helper.toastErr(this, 'file ' + file.name + ' bukan PDF')
                                return
                            }
                        } else {
                            if (file.file.type != "application/pdf") {
                                this.$helper.toastErr(this, 'file ' + file.name + ' bukan PDF')
                                return
                            }
                        }
                    }

                    this.$bvModal.show("modal-confirm-submit-se")
                }
            }


        },

        onSubmitSE() {

            this.isSubmitting = true
            let payload = new FormData()
            payload.append("menu", "anggota")
            payload.append("jenis", "anggota")
            //File PDF
            if (this.input.filePDF != null) {

                for (var file of this.input.filePDF) {

                    if (file.size != null) {
                        //untuk struktur form file baru

                        payload.append("pdfFiles", file)
                    }
                    else if (file.file.size != null) {
                        //untuk struktur form file Lama
                        payload.append("pdfFiles", file.file)
                    } else {
                        //Jika tidak Update Kirim File Kosong
                        let metadata = {
                            type: 'application/pdf'
                        }
                        let fileInput = new File([], "pdf", metadata)
                        payload.append("pdfFiles", fileInput)
                    }
                }
            }

            this.$axios.post("surat-edaran/insertOrUpdate/", payload).then(() => {
            })
                .catch(error => {
                    console.log(error)
                    console.log(error.response.data.reason)
                    this.$helper.parseError(this, error)
                    this.toggleBusy()
                    this.loading = false
                })
                .finally(() => {
                    this.isSubmitting = false
                    this.$bvModal.hide('modal-confirm-submit-se')
                    this.$bvModal.hide('modal-SE')
                    location.reload()
                })
        },

        removeSE() {

            for (var file of this.pdf.urlPDF.files) {

                let idx = this.pdfNewVal.findIndex(item => item.name == file.name)

                if (idx == -1) {
                    if (file.path.id != undefined) {
                        this.hapusSE.push(file.path.id)
                    }
                }
            }

            this.pdf.urlPDF.files = this.pdfNewVal
            this.pdfRecords = this.pdfNewVal
            this.$bvModal.hide("modal-hapus-se")
        },

        cancel() {
            this.url = this.urlRecord
            this.$bvModal.hide('modal-SE')
        },

        blackList(item) {
            this.activeItem = item
            this.form.reason = ''
            this.$bvModal.show('modal-blacklist')
        },

        unBlacklist(item) {
            this.activeItem = item
            this.form.reason = ''

            this.$axios.get("/nasabah-blacklist/blacklist-data?nasabahId=" + item, { timeout: 300000 }).then(response => {
                this.loading = false
                this.activeItem = response.data
                this.activeItem.id = item
                this.$bvModal.show('modal-unBlacklist')
            })
                .catch(error => {
                    this.$helper.parseError(this, error)
                    this.loading = false
                })


        },

        confirmBlacklist() {
            if (this.$helper.isNullOrEmpty(this.form.reason) || this.$helper.isNullOrEmpty(this.form.regarding)) {
                return this.$helper.toastErr(this, 'Mohon Lengkapi Data')
            }
            this.$bvModal.show('conf-blacklist')
        },

        confirmUnBlacklist() {
            if (this.$helper.isNullOrEmpty(this.form.reason)) {
                return this.$helper.toastErr(this, 'Mohon Lengkapi Data')
            }
            this.$bvModal.show('conf-unBlacklist')
        },

        onSubmitBlacklist() {
            this.loading = true
            let params = `?nasabahId=${this.activeItem}&reason=${this.form.reason}&regarding=${this.form.regarding.id}`

            this.$axios.post("/nasabah-blacklist/add-to-blacklist" + params, { timeout: 300000 }).then(() => {
                this.loading = false
                this.getAnggota()
                this.$bvModal.hide('modal-blacklist')
                this.$bvModal.hide('conf-blacklist')
                this.$helper.toastSucc(this, "Anggota Berhasil DiBlacklist")
                this.form.reason = ''
            })
                .catch(error => {
                    this.$helper.parseError(this, error)
                    this.loading = false
                })
        },
        onSubmitUnBlacklist() {
            this.loading = true
            let params = `?nasabahId=${this.activeItem.id}&reason=${this.form.reason}`

            this.$axios.post("/nasabah-blacklist/remove-from-blacklist" + params, { timeout: 300000 }).then(() => {
                this.loading = false
                this.getAnggota()
                this.$bvModal.hide('modal-unBlacklist')
                this.$bvModal.hide('conf-unBlacklist')
                this.$helper.toastSucc(this, "Berhasil Lepas Blacklist Anggota")
                this.form.reason = ''
            })
                .catch(error => {
                    this.$helper.parseError(this, error)
                    this.loading = false
                })
        },
        showIdentitas(item){
            this.anggotaDetail = item
            this.$bvModal.show('modal-identitas-list-c')
        },
        onShowModalListRekening(row) {
            const rowData = {
                id: row.id,
                namaAnggota: row.nama,
                noAnggota: row.no,
            }

            this.selectedRow = rowData
            this.$bvModal.show("modal-list-rekening-bank")
            this.getListRekening()
        },
        getListRekening() {
            this.stateListRekening.isLoading = true;
            this.stateListRekening.error = null;
            const id = this.selectedRow.id;
            this.$axios.get(`nasabah/list-bank/${id}`)
                .then((response) => {
                    this.stateListRekening.data = response.data
                })
                .catch((error) => {
                    const errorMessage = error.response.data.reason || error.response.data.error;
                    this.stateListRekening.error = errorMessage;
                })
                .finally(() => {
                    this.stateListRekening.isLoading = false;
            })
        },
        showModalConfirmEditAnggota(value) {
            this.selectedRow = value;
            if (this.$helper.isNullOrEmpty(value.notes)) {
                this.$helper.toastErr(this, "Mohon isi alasan terlebih dahulu.")
                return
            }

            if (value.key.includes('no-handphone') && this.$helper.isNullOrEmpty(value.attachments)) {
                this.$helper.toastErr(this, "Mohon isi foto pendukung terlebih dahulu.")
                return
            }

            if (value.key.includes('no-handphone')) {
                this.$bvModal.show('modal-request-edit-no-handphone')
            }

            if (value.key.includes('name')) {
                this.$bvModal.show('modal-request-edit-name')
            }
        },
        handleApproval(field) {
            const value = this.selectedRow;
            const cabangId = localStorage.getItem('activeCabangId');

            const payload = new URLSearchParams();

            if (field === 'no-handphone') {
                const attachmentsValue = Array.isArray(value.attachments) 
                    ? JSON.stringify(value.attachments) 
                    : value.attachments;
                    
                payload.append('attachments', attachmentsValue);
            }

            let dataType = '';
            if (field === 'no-handphone') {
                dataType = 'no_handphone_sekarang'
            }

            if (field === 'name') {
                dataType = 'nama'
            }

            this.isLoadingReqApproval = true

            const params = {
                dataType: dataType,
                value: value.newValue,
                note: value.notes,
                nasabahId: value.row.id,
                cabangId: cabangId,
            };

            const headers = {
                'Content-Type': 'application/x-www-form-urlencoded',
            };

            this.$axios.post('/nasabah/request-update-data', payload, { 
                params: params, 
                headers: headers 
            })
            .then(response => {
                this.$helper.toastSucc(this, response.data.name)
                this.$bvModal.hide(`modal-approval-${this.selectedRow.key}`)

                if (field === 'no-handphone') {
                    this.$bvModal.hide('modal-request-edit-no-handphone')
                }

                if (field === 'name') {
                    this.$bvModal.hide('modal-request-edit-name')
                }
            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isLoadingReqApproval = false;
            })
        }
    },

    watch: {
        "pdf.urlPDF.files": function (newVal) {

            this.pdfRecords = this.pdf.urlPDF.files
            //Hapus SE
            if (this.pdf == {}) {

            }
            else if (this.pdfRecords.length > newVal.length) {

                this.pdf.urlPDF.files = this.pdfRecords
                this.pdfNewVal = newVal
                this.$bvModal.show("modal-hapus-se")
            }
            //Tambah SE
            else {
                let pdf = []

                for (var file of this.pdf.urlPDF.files) {

                    pdf.push(file)
                }

                this.input.filePDF = pdf
                this.pdfRecords = pdf

            }

        },

        "pdf.file.fileList": function () {

            let Pdfbase64 = []
            for (var file of this.pdf.file.fileList) {

                Pdfbase64.push(file)
            }

            this.input.filePDF = Pdfbase64

        },

    },

    created() {
        this.init()
    }
}
</script>
